import { hbs } from 'ember-cli-htmlbars';
export default hbs("<th class=\'table__th\' ...attributes>\n  {{#if (has-block)}}\n    {{yield}}\n  {{else}}\n    <span class=\'bold\'>\n      {{@title}}\n    </span>\n  {{/if}}\n</th>")